// extracted by mini-css-extract-plugin
export default {"statusWrapper":"tender-notify-status_statusWrapper__FOt+0","statusTitle":"tender-notify-status_statusTitle__ukYcr","status":"tender-notify-status_status__KVtYy"};